/**
 * Curates Yotpo reviews into theme Product JSON-LD (review array only).
 * aggregateRating stays server-rendered from yotpo.preloaded_bottomline.
 */
(function () {
  var cfg = window.AFAProductSchemaReviews;
  if (!cfg || !cfg.productId || !cfg.appKey) {
    return;
  }

  var MIN_CHARS = 50;
  var MIN_WORDS = 8;
  var LIMIT = 5;

  function wordCount(text) {
    return text.trim().split(/\s+/).filter(Boolean).length;
  }

  function isEligible(review) {
    var body = (review.content || '').trim();
    var title = (review.title || '').trim();
    var author = review.user && review.user.display_name ? review.user.display_name : '';
    var date = review.created_at ? review.created_at.slice(0, 10) : '';
    var score = Number(review.score);

    if (!body || !date || score < 1 || score > 5) {
      return false;
    }
    if (!author || author === 'Anonymous' || author === 'Customer') {
      return false;
    }
    if (body.toLowerCase() === title.toLowerCase()) {
      return false;
    }
    if (body.length < MIN_CHARS || wordCount(body) < MIN_WORDS) {
      return false;
    }
    return true;
  }

  function reviewRank(review) {
    var len = (review.content || '').trim().length;
    // Length is primary; verified buyer only breaks ties.
    return len * 2 + (review.verified_buyer ? 1 : 0);
  }

  function pickBest(pool, scoreFilter, pickedKeys) {
    var best = null;
    var bestRank = -1;
    var i;
    var review;
    var key;
    var rank;

    for (i = 0; i < pool.length; i++) {
      review = pool[i];
      if (Number(review.score) !== scoreFilter) {
        continue;
      }
      key = (review.content || '').slice(0, 120);
      if (pickedKeys[key]) {
        continue;
      }
      rank = reviewRank(review);
      if (rank > bestRank) {
        bestRank = rank;
        best = review;
      }
    }
    return best;
  }

  function pickReviews(reviews) {
    var pool = [];
    var picked = [];
    var pickedKeys = {};
    var i;
    var fourStar;
    var fiveStar;

    for (i = 0; i < reviews.length; i++) {
      if (isEligible(reviews[i])) {
        pool.push(reviews[i]);
      }
    }

    if (!pool.length) {
      return picked;
    }

    if (picked.length < LIMIT) {
      fourStar = pickBest(pool, 4, pickedKeys);
      if (fourStar) {
        picked.push(fourStar);
        pickedKeys[(fourStar.content || '').slice(0, 120)] = true;
      }
    }

    while (picked.length < LIMIT) {
      fiveStar = pickBest(pool, 5, pickedKeys);
      if (!fiveStar) {
        break;
      }
      picked.push(fiveStar);
      pickedKeys[(fiveStar.content || '').slice(0, 120)] = true;
    }

    return picked;
  }

  function toSchemaReview(review) {
    var author = review.user && review.user.display_name ? review.user.display_name : 'Customer';
    var date = review.created_at ? review.created_at.slice(0, 10) : '';
    var out = {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: author
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: String(review.score),
        bestRating: '5',
        worstRating: '1'
      },
      reviewBody: (review.content || '').trim()
    };

    if (date) {
      out.datePublished = date;
    }

    return out;
  }

  var scriptEl = document.getElementById(cfg.scriptId || 'afa-product-json-ld');
  if (!scriptEl) {
    return;
  }

  var apiUrl =
    'https://api-cdn.yotpo.com/v1/widget/' +
    encodeURIComponent(cfg.appKey) +
    '/products/' +
    encodeURIComponent(String(cfg.productId)) +
    '/reviews.json?per_page=50&page=1';

  fetch(apiUrl)
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      var reviews = data && data.response && data.response.reviews;
      var selected;
      var schema;

      if (!reviews || !reviews.length) {
        return;
      }

      selected = pickReviews(reviews);
      if (!selected.length) {
        return;
      }

      try {
        schema = JSON.parse(scriptEl.textContent);
      } catch (e) {
        return;
      }

      schema.review = selected.map(toSchemaReview);
      scriptEl.textContent = JSON.stringify(schema);
    })
    .catch(function () {});
})();
